import ProtectedRoute from 'uplisting-frontend/pods/base/protected-route';

export default class DirectListingsRoute extends ProtectedRoute {
  model() {
    return this.store.findAll('direct-listing');
  }
}
